export class SelectObject<T> {
  display: string;
  value: T;

  constructor(display: string, value: T) {
    this.display = display;
    this.value = value;
  }
}
